import { Pipe, PipeTransform } from '@angular/core';
import { ValidaCpfService } from '../services/valida-cpf.service';
import { isNullOrUndefined } from '../../util/is-null-or-undefined.util';

@Pipe({
  name: 'MaskCpfPipe',
  standalone: false,
})
export class MaskCpfPipe implements PipeTransform {
  constructor(private servicoValidadorCpf: ValidaCpfService) {}
  /**
   * Método responsável por manipular o texto e aplicar/remover máscara
   *
   * @param texto
   * @param removeMascara
   */
  transform(texto: string, removeMascara: boolean): string {
    if (!texto) return '';

    texto = this.retirarFormatacao(texto);

    if (removeMascara) {
      return texto;
    }

    if (texto.length === 11) {
      if (this.servicoValidadorCpf.validarCPF(texto)) {
        return this.mascaraCpf(texto);
      }
    }

    return this.mascaraCpf(texto);
  }

  /**
   * Método que remover caracteres especiais do texto
   *
   * @param texto
   */
  retirarFormatacao(texto: string): string {
    if (isNullOrUndefined(texto)) {
      return texto;
    }
    return texto.toString().replace(/(\.|\/|\-)/g, '');
  }

  /**
   * Método responsável por aplicar máscara de cpf ao texto
   *
   * @param valor
   */
  private mascaraCpf(valor) {
    return valor
      .toString()
      .replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
  }
}
